import { AddToLoggedOutRouteAllowlist } from 'api/apiReqSagaCreator/httpRequest';
import { ApiPaths } from 'api/constants';
import BaseRepo from 'container/BaseRepo';
import { isApiError } from 'container/models';

import {
  ApplicationConfiguration,
  IApplicationConfigurationRepo,
} from './IApplicationConfiguraton';

export class ApplicationConfigurationRepo
  extends BaseRepo
  implements IApplicationConfigurationRepo
{
  getApplicationConfiguration = () =>
    this.helpers
      .handleGet<ApplicationConfiguration>(
        ApiPaths.applicationConfiguration(),
        {
          responseStopTransformPaths: ['identity_providers.authenticate'],
        }
      )
      .then((response) => {
        if (!isApiError(response)) {
          Object.values(response.identityProviders.authenticate).forEach(
            AddToLoggedOutRouteAllowlist
          );

          AddToLoggedOutRouteAllowlist(
            response.identityProviders.postAuthenticate
          );
        }

        return response;
      });
}
